import { shopPrefix } from '../../config';
import { http } from '../axios';
import { AddProductsFromCatalogueByIdsRequest } from './addProductsFromCatalogueByIds';
import { BulkAddProductsToShoppingCartResponse } from '../../store/api';

interface AddProductsFromBundleByIdsParams {
    params: {
        bundleId: string;
        performChecks?: boolean;
    };
    body: AddProductsFromCatalogueByIdsRequest;
}

const url = `${shopPrefix}/v2/shoppingcart/bulk/bundle/:bundleId/productIds/add`;

export const addProductsFromBundleByIds = async ({ body, params }: AddProductsFromBundleByIdsParams) => {
    return http
        .post<BulkAddProductsToShoppingCartResponse>(url, body, {
            pathParams: {
                bundleId: params.bundleId
            },
            params: {
                performChecks: params.performChecks
            }
        })
        .then(({ data }) => data);
};
